import React from 'react'
const SearchOptionContext = React.createContext()
export default SearchOptionContext
